import { render, staticRenderFns } from "./InfoDeskPage.vue?vue&type=template&id=5c424697&scoped=true&"
import script from "./InfoDeskPage.vue?vue&type=script&lang=ts&"
export * from "./InfoDeskPage.vue?vue&type=script&lang=ts&"
import style0 from "./InfoDeskPage.vue?vue&type=style&index=0&id=5c424697&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c424697",
  null
  
)

export default component.exports